import Vue from 'vue'
import VueRouter from 'vue-router'
import Main from '../views/main/MainView'
import KnowledgeManagement from '../views/knowledgeManagement/knowledgeManagement'
import ChannelView from "@/views/channel/channelView";
import AccessBind from "@/views/channel/accessBind";
import AccessInformation from "@/views/channel/accessInformation";
import PersonalV2 from "@/views/personal/personalV2";
import versionManage from "@/views/versionManage/versionManage.vue";
import labelIndex from "@/views/labelManagement/labelIndex";
import KnowledgeCollection from "@/views/knowledgeCollection/knowledgeCollection";
import AiGenerateKnowledge from "@/views/aiGenerateKnowledge/aiGenerateKnowledge.vue";
import AiGenerateKnowledgeCreate from "@/views/aiGenerateKnowledge/aiGenerateKnowledgeCreate.vue";

import { GetQueryString } from "@/assets/js/filterTree";
import NewsAnnouncement from "@/views/newsAnnouncement/newsAnnouncement";
import AddNewsAnnouncement from "@/views/newsAnnouncement/addNewsAnnouncement";
import KnowledgeAnalysis from "@/views/statisticalAnalysis/KnowledgeAnalysis";
import KnowledgeOverview from "@/views/statisticalAnalysis/knowledgeOverview";
import contractTemplateManagement from "@/views/contractManagement/contractTemplateManagement.vue";
import contractTemplateFieldManagement from "@/views/contractManagement/contractTemplateFieldManagement";
import contractTemplateFieldconfigure from "@/views/contractManagement/contractTemplateFieldConfigure.vue"
import Automation from '@/views/automation/autoIndex'
import Subsection from "@/views/versionManage/components/subsection";
import PdfView from "@/views/versionManage/components/pdfView";
import knowledgeCollection from "@/views/knowledgeCollection/knowledgeCollection";
/**
 * 重写路由的push方法
 * 解决:vue在3.0以上的版本中的错误提示，不允许从当前路由跳转到当前路由
 * 添加，相同路由跳转时，触发watch (针对el-menu，仅限string方式传参，形如"view?id=5")
 */
const originalPush = VueRouter.prototype.push
const originalReplace = VueRouter.prototype.replace;
VueRouter.prototype.push = function push (location) {
  // 这个语句用来解决报错 调用原来的push函数，并捕获异常
  return originalPush.call(this, location).catch(err => err)
}
VueRouter.prototype.replace = function push (location, onResolve, onReject) {
  if (onResolve || onReject)
    return originalReplace.call(this, location, onResolve, onReject);
  return originalReplace.call(this, location).catch(err => err);
};
Vue.use(VueRouter)
/**
 * 在知识管理应用端使用iframe引入页面时只使用knowledgeManagement页面，进行路由配置
 * */
let isAskLightning = GetQueryString('isAskLightning');
console.debug('isAskLightning', isAskLightning)
let routes = [];
if (isAskLightning == 1) {
  routes = [
    {
      path: '/',
      redirect: '/knowledge_Management'
    },
    {
      path: "/knowledge_Management",
      name: "knowledgeManagement",
      component: KnowledgeManagement,
      meta: {
        title: "知识管理",
        icon: "iconfont guoran-tongyichicun-zujianzhishiku"
      }
    },
  ]
} else if (isAskLightning == 2){
  routes = [
    {
      path: '/',
      component: () => import("../views/auth/dialogAuth"),
    },
    {
      path: '/auth',
      name:"AuthView",
      meta: { title: '首页' },
      component: () => import("../views/auth/Auth"),
    },
    {
      path: '/main',
      name: 'MainView',
      component: Main,
      children:[
        {
          path: "/knowledge_Management",
          name: "knowledgeManagement",
          component: KnowledgeManagement,
          meta: {
            title: "知识管理",
            icon: "iconfont guoran-tongyichicun-zujianzhishiku",
            belong: "knowledge"
          }
        },
        {
          path: "/knowledge_collection",
          name: "knowledgeCollection",
          component: knowledgeCollection,
          meta: {
            title: "知识采集",
            icon: "iconfont guoran-shujucaiji"
          }
        },
        {
          path: "/knowledge_collection/task/:taskId",
          name: "taskDetail",
          component: () => import("@/views/knowledgeCollection/TaskDetail.vue"),
          meta: {
            title: "任务详情",
            icon: "iconfont guoran-shujucaiji"
          }
        },
        {
          path: "/knowledge_collection/results",
          name: "allCollectionResults",
          component: () => import("@/views/knowledgeCollection/AllCollectionResults.vue"),
          meta: {
            title: "采集结果",
            icon: "iconfont guoran-shujucaiji"
          }
        },
        {
          path: '/versionManage',
          name: "versionManage",
          component: versionManage,
          meta: {
            title: '知识管理',
            belong: "knowledge"
          }
        },
        {
          path: "/ai_generate_knowledge",
          name: "aiGenerateKnowledge",
          component: AiGenerateKnowledge,
          meta: {
            title: "AI生成知识",
            icon: "iconfont guoran-AIshengchengku"
          }
        },
        {
          path: "/ai_generate_knowledge/create",
          name: "aiGenerateKnowledgeCreate",
          component: AiGenerateKnowledgeCreate,
          meta: {
            title: "AI生成知识",
            icon: "iconfont guoran-AIshengchengku"
          }
        },
      ]
    },
    {
      path: '/versionManage',
      name: "versionManage",
      component: versionManage,
      meta: {
        title: '知识管理',
        belong: "knowledge"
      }
    },
  ]
} else {
  routes = [
    {
      path: '/',
      meta: { title: '首页' },
      component: () => import("../views/auth/Auth"),
    },
    {
      path: '/main',
      name: 'MainView',
      component: Main,
      children: [
        {

          path: "/knowledge_Management",
          name: "knowledgeManagement",
          component: KnowledgeManagement,
          meta: {
            title: "知识管理",
            icon: "iconfont guoran-tongyichicun-zujianzhishiku",
            belong: "knowledge"
          }
        },
        {
          path: "/channel_management",
          name: "channel",
          component: ChannelView,
          meta: {
            title: "渠道管理",
            icon: "iconfont guoran-tongyichicun-qudaoguanli",
            keepAlive: false,

          }
        },
        {
          path: "/labelIndex",
          name: "labelIndex",
          component: labelIndex,
          meta: {
            title: "标签管理",
            icon: "iconfont guoran-biaoqian2"
          }
        },
        {
          path: "/knowledge_collection",
          name: "knowledgeCollection",
          component: KnowledgeCollection,
          meta: {
            title: "知识采集",
            icon: "iconfont guoran-shujucaiji"
          }
        },
        {
          path: "/ai_generate_knowledge",
          name: "aiGenerateKnowledge",
          component: AiGenerateKnowledge,
          meta: {
            title: "AI生成知识",
            icon: "iconfont guoran-AIshengchengku"
          }
        },
        {
          path: "/ai_generate_knowledge/create",
          name: "aiGenerateKnowledgeCreate",
          component: AiGenerateKnowledgeCreate,
          meta: {
            title: "AI生成知识",
            icon: "iconfont guoran-AIshengchengku"
          }
        },
        {
          path: "/knowledge_collection/task/:taskId",
          name: "taskDetail",
          component: () => import("@/views/knowledgeCollection/TaskDetail.vue"),
          meta: {
            title: "任务详情",
            icon: "iconfont guoran-shujucaiji"
          }
        },
        {
          path: "/knowledge_collection/results",
          name: "allCollectionResults",
          component: () => import("@/views/knowledgeCollection/AllCollectionResults.vue"),
          meta: {
            title: "采集结果",
            icon: "iconfont guoran-shujucaiji"
          }
        },
        {
          path:"/contract_template",
          name:"contract_template",
          component: contractTemplateManagement,
          meta:{
            title:"合同模板管理",
            icon:"iconfont guoran-biaoqian2"
          }
        },
        {
          path:"/template_field",
          name:"template_field",
          component: contractTemplateFieldManagement,
          meta:{
            title:"合同模板字段管理",
            icon:"iconfont guoran-biaoqian2",
            belong: "contract"
          }
        },
        {
          path: "/template_field_configure",
          name: "template_field_configure",
          component: contractTemplateFieldconfigure,
          meta: {
            title: "合同模板字段配置",
            icon: "iconfont guoran-biaoqian2",
            belong: "contract"
          }
        },
        {
          path: "/accessBind",
          name: "accessBind",
          component: AccessBind,
          meta: {
            title: "渠道介入",
            icon: "iconfont guoran-tongyichicun-qudaojieru",
            belong: "channel"
          }
        },
        {
          path: "/accessInformation",
          name: "accessInformation",
          component: AccessInformation,
          meta: {
            title: "接入信息",
            icon: "iconfont guoran-tongyichicun-qudaojieru",
            belong: "channel"
          }
        },
        {
          path: '/personal',
          name: "personal",
          component: PersonalV2,
          meta: {
            title: '个人中心'
          }
        },
        {
          path: '/versionManage',
          name: "versionManage",
          component: versionManage,
          meta: {
            title: '知识管理',
            belong: "knowledge"
          }
        },
        {
          path: '/automation',
          name: 'automation',
          component: Automation,
          meta: {
            title: '自动化流程',
            icon:"iconfont guoran-tongyichicun-14-12-zidonghualiucheng",
            belong: ""
          }
        },
        {
          path: '/news_announcementManage',
          name: "newsAnnouncementManage",
          component: NewsAnnouncement,
          meta: {
            title: '新闻公告管理',
            icon: "iconfont guoran-xinwengao",

          }
        },
        {
          path: '/addNewsAnnouncement',
          name: "addNewsAnnouncement",
          component: AddNewsAnnouncement,
          meta: {
            title: '新闻公告管理',
            icon: "iconfont guoran-xinwengao",
            belong: "news"
          }
        },
        {
          path: '/weboffice',
          name: 'WebOfficePage',
          component: () => import(/* webpackChunkName: "about" */ '../views/versionManage/webOfficePage.vue'),
          props: route => ({
            officeType: route.query.officeType,
            fileId: route.query.fileId,
            userId: route.query.userId,
            currentVersion: route.query.currentVersion,
          }),
        },
        {
         path: "/analysis_KnowledgeAnalysis",
          name:"analysis_KnowledgeAnalysis",
          component: KnowledgeAnalysis,
          meta:{
            title:"知识分析",
            icon:"iconfont guoran-tongyichicun-zhishiku",
            belong:"analysis"
          }
        },
        {
          path:"/analysis_knowledgeOverview",
         name: "analysis_knowledgeOverview",
          component: KnowledgeOverview,
          meta:{
           title: "知识总览",
           icon: "iconfont guoran-zonglan",
            belong:"analysis"
          }
        },
        {
          path: '/subsection',
          name: 'subsection',
          component: Subsection,
          meta: {
            title: '分段',
            belong: ""
          }
        },
        {
          path: '/pdfView',
          name: 'pdfView',
          component: PdfView,
          meta: {
            title: '分段',
            belong: ""
          }
        },
        {
          path: '/notification',
          name: 'notification',
          component: () => import('@/views/notification/index.vue'),
          meta: {
            title: '通知中心',
            icon: 'el-icon-bell',
            belong: 'notification'
          }
        },
        {
          path: '/todo',
          name: 'todo',
          component: () => import('@/views/notification/todo.vue'),
          meta: {
            title: '待办事项',
            icon: 'el-icon-time',
            belong: 'notification'
          }
        },
        {
          path: '/notification-test',
          name: 'notificationTest',
          component: () => import('@/views/notification/test.vue'),
          meta: {
            title: '通知测试',
            icon: 'el-icon-setting',
            belong: 'notification'
          }
        },
        {
          path: '/websocket-status',
          name: 'websocketStatus',
          component: () => import('@/views/notification/WebSocketStatus.vue'),
          meta: {
            title: 'WebSocket状态',
            icon: 'el-icon-connection',
            belong: 'notification'
          }
        },
        {
          path: '/proper_noun',
          name: 'properNoun',
          component: () => import('@/views/properNoun/properNounManagement.vue'),
          meta: {
            title: '知识专有名词库',
            icon: 'iconfont guoran-ziduan1'
          }
        },
      ]
    },

  ]
}

const router = new VueRouter({
  routes
})

router.beforeEach((to, from, next) => {
  if (sessionStorage.getItem("_token")) {
    next()
  } else {
    if (to.path == '/' || to.path == '/knowledge_Management' || to.path == '/auth') {
      next()
    } else {
      if(to.path == '/versionManage') {
        let query = JSON.stringify(to.query)
        sessionStorage.setItem('toVersionManage', query)
      }
      next({
        path: to.path,
        query: to.query
      })
    }
  }
})



export default router
